<template>
  <div :class="`stats-name-wrap stats-name-wrap__` + statusData.dashboardType">
    <span class="stats-number" :class="{ 'today-row': !isClosed }">{{statusCounter}}</span>
    <span class="arrow-up" v-if="isClosed && lastCounter < statusCounter"></span>
    <span class="arrow-down" v-if="isClosed && lastCounter > statusCounter"></span>
    <br>
    <div class="stats-bar" v-if="isClosed"></div>
    <div class="stats-bar" v-else :style="{ backgroundColor: statusData.dashboardColor }"></div>
    <span class="stats-name"> {{ statusData.dashboardLabel }}</span>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    statusData: {
      type: Object | Array,
      default: []
    },
  },
  data() {
    return {
      statusCounter: 0,
      lastCounter: 0,
      isClosed: false,
        filterQuery: {
                sort: "",
                query: "",
                filterByDate: false,
                filterByTaskDate: false,
                filterByDateCreated: false,
                dateRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                taskDateRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                dateCreatedRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                dateCompletedRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                status: [],
                outlet: [],
                deliverableType: [],
                tag: [],
                department: [],
                coordinator: [],
                project: [],
                noDepartment: "not_accepted",
                noOutlet: "not_accepted",
                weekFilterOptions: {
                    overdue: false,
                    today: false,
                    thisWeek: false,
                    nextWeek: false,
                    upcoming: false,
                    noDeadline: false,
                },
                dashboardType: 'numberSet',
            },
    };
  },
  computed: {
    ...mapGetters([
        "numberStat"
    ])
  },
  async mounted() {
    await this.fetchList();

    this.timer = setInterval(this.fetchList, 10000);

      Echo.channel('deliverable').listen('DeliverableUpdated', (e) => {
        if (this.statusData.dashboardType.includes("closed")) {
            if ( e.deliverable.completed_at != null){
            this.fetchList();
            }
        }
		});
        let tryCount = 0;
		Echo.channel('task').listen('TaskUpdated', (e) => {
      if (this.statusData.dashboardType.includes("today")) {
                tryCount = tryCount +1;
                    this.fetchList();
                    tryCount = 0;
      }
		});


  },
  methods: {
      ...mapActions([
			"fetchNumberStat",
		]),
        async fetchList(){

          this.filterQuery.dashboardType = this.statusData.dashboardType;
          this.filterQuery.deliverableType = this.statusData.dashboardFilter.deliverableType;
          // Use task status or deliverable status flag - all task Not Started then Not Started, else In Progress
          // one deliverable should not be shown in both Not Started and In Progress counts
          this.filterQuery.useDeliverableStatusForFilter = this.statusData.dashboardFilter.useDeliverableStatusForFilter;

          if (this.statusData.dashboardType.includes("today_")) {
            // today = 00:00 - 23:59 
            const fromDate = this.$moment.utc().startOf('day');
            const endDate = this.$moment.utc().endOf('day');
            this.filterQuery.dateCreatedRange.startDate = fromDate.format();
            this.filterQuery.dateCreatedRange.endDate = endDate.format();
            this.filterQuery.filterByDateCreated = true;
            this.filterQuery.status = this.statusData.dashboardFilter.status;
          }

   		 this.$store.commit("setDashboardMediaCallsFilter", this.filterQuery);
          await this.fetchNumberStat();
          this.$nextTick(() => {
            if (this.statusData.dashboardType.includes("closed_")) {
              this.isClosed = true;
              this.lastCounter = this.numberStat.lastCount;
            }
            this.statusCounter = this.numberStat.count;
          })

        }
  },
};
</script>

<style>
</style>
